import { StyledText } from "../../../../components/common";
import { CheckCirclIcon } from "../../../../components/svgs";

export const Stepper = ({ currentPage, navigateFunc, background, steps }) => {
  const activeBgColor = "#00678F";
  const inactiveBgColor = "#C8CBCB";
  return (
    <div style={{ textAlign: "center" }}>
      <div style={{ position: "relative", display: "inline-block", zIndex: 1 }}>
        {steps.map((label, index) => {
          const isActive = currentPage >= index;
          return (
            <div
              style={{
                cursor: "pointer",
                display: "inline-block",
                position: "relative",
                marginLeft: index === 0 ? "0" : "-20px",
                padding: `5px 30px 5px 20px`,
                paddingLeft: index === 0 ? "20px" : "30px",
                border: "1px solid #fff",
                borderRadius: "20px",
                color: "#fff",
                zIndex: steps.length - index,
                background: isActive
                  ? steps.length - 1 === index
                    ? background
                    : activeBgColor
                  : inactiveBgColor,
              }}
              key={label}
              onClick={() => (isActive ? navigateFunc(index) : {})}
            >
              <StyledText
                size={10}
                style={{ fontFamily: "MTNMedium" }}
                margin="0"
              >
                {label}
              </StyledText>
              <div
                style={{
                  position: "absolute",
                  right: "7px",
                  top: "3px",
                  visibility: isActive ? "visible" : "hidden",
                }}
              >
                <CheckCirclIcon
                  fill={"#fff"}
                  color={
                    steps.length - 1 === index ? background : activeBgColor
                  }
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
